export const isJsonString = (str: string): boolean => {
  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }
  return true;
};

export const parseToPlainText = (value: string | null | undefined): string => {
  if (value) {
    try {
      const isJson = isJsonString(value);
      let parsedValue = value;

      if (isJson) {
        parsedValue = JSON.parse(value);
      }

      return parsedValue.replace(/(<([^>]+)>)/gi, '');
    } catch (error) {
      return '';
    }
  }

  return '';
};

export const parseForInnerHTML = (value: string | null | undefined): string => {
  if (value) {
    const isJson = isJsonString(value);
    let parsedValue = value;

    if (isJson) {
      parsedValue = JSON.parse(value);
    }

    return parsedValue;
  }

  return '';
};

/**
 * Unwrap a single top-level block tag so CMS copy can be rendered inside a
 * heading element.
 *
 * CMS titles arrive wrapped, e.g. `"<p>CONNECTING THE SPORT WORLD</p>"`.
 * Nesting a block inside a heading is invalid HTML, so the wrapper is dropped
 * when — and only when — the value is exactly one block. Multi-block values
 * are returned untouched for the caller to render in a container.
 */
export const unwrapSingleBlock = (
  value: string | null | undefined
): { html: string; wasSingleBlock: boolean } => {
  const html = parseForInnerHTML(value).trim();

  if (!html) {
    return { html: '', wasSingleBlock: false };
  }

  const match = html.match(/^<(p|div|h[1-6])(\s[^>]*)?>([\s\S]*)<\/\1>$/i);

  // Reject values that close and reopen a block — those are multi-block.
  if (!match || /<\/(p|div|h[1-6])>/i.test(match[3])) {
    return { html, wasSingleBlock: false };
  }

  return { html: match[3].trim(), wasSingleBlock: true };
};
